<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center" style="gap: 10px">
        <div class="d-block">
          <div class="section-title">{{ $t("movie_pass") }}</div>
          <div class="section-subTitle my-2">
            {{ $tc("movie_pass_dash_msg") }}
          </div>
        </div>
        <div>
          <b-form-input
            v-debounce:300="onSearchMoviePass"
            v-model="searchValue"
            :placeholder="$tc('searchs')"
          ></b-form-input>
        </div>
      </div>

      <div class="d-flex align-items-center" style="gap: 10px">
        <div>
          <b-button variant="default" to="add-movie-pass" class="btn-blue">{{
            $t("add")
          }}</b-button>
        </div>

        <div class="d-flex align-items-center">
          <FilterByStatusDropdown
            :onSelect="
              (filterIsActive) => {
                getMoviePasses(filterIsActive);
              }
            "
          />
          <div class="mx-2">
            <b-dropdown id="listview" variant="outline-blue">
              <template v-slot:button-content>
                <strong>{{ viewingRange }}</strong>
              </template>
              <b-dropdown-item
                v-for="(list, listIndex) in viewingnumbers"
                :key="listIndex"
                @click="onDropDownChangeValue(list.name)"
                href="#"
                >{{ list.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>

    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-left" style="width: 145px;">
              <span class="">{{ $tc("status", 2) }}</span>
            </th>
             <th style="width: 300px">
              <img
                v-if="this.columnName != 'pass_uuid'"
                @click="onSortValue('pass_uuid', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('pass_uuid', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('pass_uuid', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("code") }}
            </th>
            <th style="width: 250px">
              <img
                v-if="this.columnName != 'pass_name'"
                @click="onSortValue('pass_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('pass_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('pass_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("movie_pass") }}
            </th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody v-if="MoviePassList && MoviePassList.length > 0">
          <tr
            v-for="(pass, passIndex) in MoviePassList"
            :key="passIndex"
            class="light_grey_back"
          >
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    pass.pass_is_active == 'Y'
                      ? 'active'
                      : pass.pass_is_active == 'N' && 'inactive'
                  "
                />
                <div class="ml-2" v-b-tooltip="'Edit Voucher'" tabindex="0">
                  <i
                    class="edit-pen icon blue-icon cursor-pointer"
                    @click.prevent.stop="onEdit(pass)"
                  ></i>
                </div>
              </div>
            </td>
             <td>{{ pass.pass_uuid }}</td>
            <td>
              <div class="d-flex">
                {{ pass.pass_name }}
              </div>
            </td>
            <td>{{ parseFloat(pass.pass_gross_amount || 0).toFixed(3) }}</td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr>
            <td colspan="3">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-if="MoviePassList.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import moment from "moment";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      MoviePassList: [],

      gridView: false,
      listView: true,

      debounce: null,
      searchValue: "",

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
    };
  },
  mounted() {
    this.getMoviePasses();
  },
  beforeMount() {
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }
      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    moment,
    onSearchMoviePass() {
      this.currentPage = 1;
      this.getMoviePasses();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getMoviePasses();
      } else {
        this.currentPage = event;
        this.getMoviePasses();
      }
    },
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getMoviePasses();
    },
    getMoviePasses: function (filterIsActive = "Y") {
      this.MoviePassList = [];
      let loader = this.$loading.show();

      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        searchValue: this.searchValue,
        status: filterIsActive,
      };
      MarketingService.GetAllMoviePassList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.MoviePassList = data.Records;
              this.rows = data.totalRows;
            }
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    onEdit: function ({ pass_id }) {
      this.$router.push({
        path: "/cinema-manager/edit-movie-pass",
        query: { pass_id },
      });
    },
    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MoviePass/MoviePassList.vue